import {
  all,
  call,
  fork,
  put,
  takeEvery,
  take,
  select,
} from 'redux-saga/effects';
import { Map } from 'immutable';

// action creators
import {
  doneIndicator,
  success,
  error,
  errorIndicator,
} from 'store/actions/httpActions';
import { bulkInvite, fetchInvitesForGroup } from 'store/actions/inviteActions';
import {
  setFormSubmitSucceeded,
  destroyForm,
  setFormSubmitFailed,
} from 'store/actions/formActions';
import axios from 'axios';

// api
import client from 'sources/api';

// constants
import {
  FILE_CREATE_AND_INVITE_REQUEST,
  FILE_CREATE_AND_INVITE,
  FILE_UPLOAD,
} from 'store/constants/fileTypes';

// schemas
import { fileSchema } from 'store/schemas/fileSchema';

// lib
import httpSaga from 'store/sagas/httpSaga';

// selectors
import getErrorMessage from 'store/selectors/getErrorMessage';
import getStatusFromState from 'store/selectors/getStatusFromState';

const WATCH_TYPE = FILE_CREATE_AND_INVITE_REQUEST;

export function* createFileAndInviteSaga(action: any) {
  const {
    payload: { file = {}, formName, roleId, groupId, childGroupId },
  } = action;
  const { type, name } = file;

  // 1) POST /files to create file entry in db, returning file id
  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  const createResponse = yield* httpSaga(
    FILE_CREATE_AND_INVITE,
    call(client.post, '/files', {
      file_name: name,
      content_type: type,
    }),
    {
      formName,
      dispatchFormSuccess: false,
      dispatchSuccess: false,
      schema: fileSchema,
    }
  );

  if (createResponse) {
    // @ts-expect-error ts-migrate(2525) FIXME: Initializer provides no value for this binding ele... Remove this comment to see the full error message
    const { data: { id, uploadUrl } = {} } = createResponse;

    // 2) Upload file to presigned s3 URL
    const options = {
      headers: {
        'Content-Type': type,
      },
    };

    // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
    yield* httpSaga(FILE_UPLOAD, call(axios.put, uploadUrl, file, options), {
      dispatchSuccess: false,
    });

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 1.
    yield put(success(FILE_UPLOAD));
    yield put(doneIndicator(FILE_UPLOAD));

    // 2) Post file ID to tasks endpoint to be processed and initiate the worker/task to bulk invite members
    yield put(bulkInvite({ fileId: id, roleId, groupId, childGroupId }));
    // Wait for the invites to be sent
    yield take('INVITE_BULK_DONE');

    const inviteStatus = yield select(state =>
      getStatusFromState('invite')(state)
    );

    if (inviteStatus === 'error') {
      const inviteErrorMessage = yield select(state =>
        getErrorMessage('invite')(state)
      );

      const message = Map({ data: Map({ msg: inviteErrorMessage }) });
      yield put(setFormSubmitFailed(formName, message.toJS()));

      // Notify the store that this type had an error
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
      yield put(errorIndicator(FILE_CREATE_AND_INVITE, message));

      // Dispatch an error payload for this type to be caught by the reducer
      yield put(error(FILE_CREATE_AND_INVITE, message));
    } else {
      yield put(fetchInvitesForGroup({ groupId }));
      yield take('INVITE_FETCH_FOR_GROUP_DONE');

      yield put(setFormSubmitSucceeded(formName, 'Imported successfully'));
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 1.
      yield put(success(FILE_CREATE_AND_INVITE));
      yield put(destroyForm(formName));
    }
  }

  yield put(doneIndicator(FILE_CREATE_AND_INVITE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, createFileAndInviteSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
